/**
 * This component is used to display a email logs of daily, weekly and principal
 */
import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import * as emailLogsActions from "../../../store/admin";
import { bindActionCreators } from "redux";
import BootstrapTable from "react-bootstrap-table-next";
import * as moment from "moment";
import { ExportXlsxCsv } from "./export-xlsx-csv";
import { ExportPdf } from "./export-pdf";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GridLoader } from "react-spinners";
import paginationFactory from "react-bootstrap-table2-paginator";
import { css } from "@emotion/core";
import { BackStrip, Header } from "../../../common/layout";
import { deviceDetect } from "react-device-detect";
import { utilService } from "../../../common/utils";
import { config } from "../../../config/config";

const override = css`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

class EmailLogs extends React.Component {
  constructor(props) {
    super(props);
    this.onTypesChange = this.onTypesChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onReset = this.onReset.bind(this);
    this.onFilter = this.onFilter.bind(this);
    this.eamil_type_name = "PRINCIPAL";
    this.state = {
      filterData: {
        types: "PRINCIPAL",
      },
      errors: {},
      sheetData: [],
      isLoading: false,
      isReseting: false,
      isFitering: false,
    };
  }

  componentDidMount() {
    // save page visit logs to dynamodb
    let device = deviceDetect();
    let osName = utilService.getOsName(device);
    let browserName = utilService.getBrowserName(device);
    let pageLogsData = {
      ipstack_access_key: config.ipstack_access_key,
      pageId: "email-logs",
      title: "Email Logs",
      browserName: browserName,
      osName: osName,
      pageType: "Email Logs Page",
      visited_at: new Date(),
      country_name: this.props.user.country_name,
      users_userid: this.props.user.userUid,
      users_username: this.props.user.username,
      users_firstname: this.props.user.firstname,
      users_lastname: this.props.user.surname,
    };
    // save page logs
    this.props.savePageVisitLogs({
      token: this.props.token,
      data: pageLogsData,
    });

    this.props.getEmailStatistics({
      token: this.props.token,
      params: "?types=PRINCIPAL",
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.emailLogsActionLoading &&
      !this.props.emailLogsActionLoading
    ) {
      if (prevState.isReseting) {
        this.setState({
          isLoading: false,
          isReseting: false,
        });
      }

      if (prevState.isFitering) {
        this.setState({
          isLoading: false,
          isFitering: false,
        });
      }
    }
  }

  /**
   * It is a method which is invoked after a component is instantiated as well as
   * when it receives new props
   * @param {*} nextProps : Getting new props from reducer
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.emailLogs && nextProps.emailLogs.length > 0) {
      if (nextProps.emailLogs !== this.props.emailLogs) {
        let format_data = [];
        let data = nextProps.emailLogs.sort(function (a, b) {
          return new Date(b.SnsPublishTime) - new Date(a.SnsPublishTime);
        });

        data.forEach((item, index) => {
          let data = {};
          if (
            this.state.filterData.types === "PRINCIPAL" ||
            this.state.filterData.types === "DIGEST" ||
            this.state.filterData.types === "DAILYEMAIL"
          ) {
            data["Email"] = item.SESDestinationAddress;
            data["SENT_DATE"] = moment(item.SnsPublishTime).format(
              "YYYY-MM-DD hh:mm a"
            );
            data["Type"] = item.type;
            data["postUid_List"] = item.postsUid ? item.postsUid.join() : "";
            data["Delivered"] = item.Delivery
              ? moment(item.Delivery["SESDeliverTime"]).format(
                  "YYYY-MM-DD hh:mm a"
                )
              : "";
            data["Opened"] = item.Open
              ? moment(item.Open["SESOpenTime"]).format("YYYY-MM-DD hh:mm a")
              : "";

            data["Clicked"] = item.Click
              ? moment(item.Click["SESClickTime"]).format("YYYY-MM-DD hh:mm a")
              : "";
          } else {
            data["UserId"] = item.user_id ? item.user_id : "";
            data["Name"] = item.user_name ? item.user_name : "";
            data["Email"] = item.SESDestinationAddress;
            data["SENT_DATE"] = moment(item.SnsPublishTime).format(
              "YYYY-MM-DD hh:mm a"
            );
            data["Type"] = item.type;
            data["Subject"] = item.subject ? item.subject : "";
            data["StudentId"] = item.student_id ? item.student_id : "";
            data["Student_Name"] = item.student_name ? item.student_name : "";
            data["Absence_Date"] = item.absence_date ? item.absence_date : "";
            data["Reason"] = item.reason ? item.reason : "";
            data["Delivered"] = item.Delivery
              ? moment(item.Delivery["SESDeliverTime"]).format(
                  "YYYY-MM-DD hh:mm a"
                )
              : "";
            data["Opened"] = item.Open
              ? moment(item.Open["SESOpenTime"]).format("YYYY-MM-DD hh:mm a")
              : "";

            data["Clicked"] = item.Click
              ? moment(item.Click["SESClickTime"]).format("YYYY-MM-DD hh:mm a")
              : "";
          }
          format_data.push(data);
        });
        this.eamil_type_name = this.state.filterData.types;
        this.setState({
          sheetData: format_data,
        });
      }
    } else {
      this.setState({
        sheetData: [],
      });
    }
  }

  onInputChange(e) {
    const { name, value } = e.target;
    let fields = this.state.filterData;
    fields[name] = value;
    this.setState({
      fields,
    });
  }

  onTypesChange(e) {
    let fields = this.state.filterData;
    if (e.target.checked) {
      fields["types"] = e.target.value;
      // this.eamil_type_name = e.target.value
      // fields['types'].push(e.target.value)
      this.setState({
        fields,
      });
    } else {
      // if (_.includes(fields.types, e.target.value)) {
      //   _.remove(fields.types, function (o) {
      //     return o === e.target.value
      //   })
      //   this.setState({
      //     fields
      //   })
      // }
    }
  }

  handleDateChange(date, name) {
    let fields = this.state.filterData;
    fields[name] = date;
    this.setState({
      fields,
    });
  }

  validateForm() {
    let fields = this.state.filterData;
    let errors = {};
    let formIsValid = true;

    if (fields["start_date"] && !fields["end_date"]) {
      formIsValid = false;
      errors["end_date"] = "*Please select end date.";
    }

    if (fields["end_date"] && !fields["start_date"]) {
      formIsValid = false;
      errors["start_date"] = "*Please select start date.";
    }

    if (fields["end_date"] < fields["start_date"]) {
      formIsValid = false;
      errors["end_date"] = "*Please select valid date.";
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  onFilter(e) {
    e.preventDefault();
    if (this.validateForm()) {
      let fields = this.state.filterData;
      let params = "?";

      if (fields["start_date"]) {
        if (params !== "?") {
          params = params + "&";
        }
        params =
          params +
          `start_date=${moment(fields["start_date"]).format("YYYY-MM-DD")}`;
      }
      if (fields["end_date"]) {
        if (params !== "?") {
          params = params + "&";
        }
        params =
          params +
          `end_date=${moment(fields["end_date"]).format("YYYY-MM-DD")}`;
      }
      if (fields["types"]) {
        if (params !== "?") {
          params = params + "&";
        }
        params = params + `types=${fields["types"]}`;
      }
      if (fields["email"]) {
        if (params !== "?") {
          params = params + "&";
        }
        params = params + `email=${fields["email"]}`;
      }
      if (fields["postUid"]) {
        if (params !== "?") {
          params = params + "&";
        }
        params = params + `postUid=${fields["postUid"]}`;
      }
      if (params === "?") {
        params = "";
      }
      // console.log(params)
      this.setState({
        isLoading: true,
        isFitering: true,
        isReseting: false,
      });
      this.props.getEmailStatistics({
        token: this.props.token,
        params: params,
      });
    }
  }

  onReset(e) {
    e.preventDefault();
    this.setState({
      filterData: {
        types: "PRINCIPAL",
      },
      isLoading: true,
      isFitering: false,
      isReseting: true,
      errors: {},
    });
    this.myFormRef.reset();
    this.props.getEmailStatistics({
      token: this.props.token,
      params: "?types=PRINCIPAL",
    });
  }

  render() {
    const { emailLogs, emailLogsData } = this.props;

    let email_type = this.eamil_type_name;
    // console.log(emailLogsData);
    let columns = [];
    // console.log("email logs ", this.state.sheetData)
    if (
      email_type === "PRINCIPAL" ||
      email_type === "DIGEST" ||
      email_type === "DAILYEMAIL"
    ) {
      columns.push(
        {
          dataField: "SESDestinationAddress",
          text: "Email",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "200px", textAlign: "left" };
          },
        },
        {
          dataField: "intended_recipient",
          text: "Intended Recipient",
          formatter: intendedRecipientFormatter,
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "200px", textAlign: "left" };
          },
        },
        {
          dataField: "Send",
          text: "SENT_DATE",
          formatter: dateFormatter,
          sort: true,
        },
        {
          dataField: "type",
          text: "Type",
          sort: true,
        },
        {
          dataField: "postsUid",
          text: "postUid_List",
          formatter: postUidFormatter,
        },
        {
          dataField: "Delivery",
          text: "Delivered",
          formatter: eventTypeDeliveredDateFormatter,
          sort: true,
        },
        {
          dataField: "Open",
          text: "Opened",
          formatter: eventTypeOpenedDateFormatter,
          sort: true,
        },
        {
          dataField: "Click",
          text: "Clicked",
          formatter: eventTypeClickedDateFormatter,
          sort: true,
        }
      );
    } else if (
      email_type === "Notify Absence" ||
      email_type === "Unverified Absence"
    ) {
      columns.push(
        {
          dataField: "user_id",
          text: "UserId",
          sort: true,
        },
        {
          dataField: "user_name",
          text: "Name",
          sort: true,
        },
        {
          dataField: "SESDestinationAddress",
          text: "Email",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "200px", textAlign: "left" };
          },
        },
        {
          dataField: "Send",
          text: "SENT_DATE",
          formatter: dateFormatter,
          sort: true,
        },
        {
          dataField: "type",
          text: "Type",
          sort: true,
        },
        {
          dataField: "subject",
          text: "Subject",
          sort: true,
        },
        {
          dataField: "student_id",
          text: "StudentId",
          sort: true,
        },
        {
          dataField: "student_name",
          text: "Student Name",
          sort: true,
        },
        {
          dataField: "absence_date",
          text: "Absence Date",
          sort: true,
        },
        {
          dataField: "reason",
          text: "Reason",
          sort: true,
        },
        {
          dataField: "Delivery",
          text: "Delivered",
          formatter: eventTypeDeliveredDateFormatter,
          sort: true,
        },
        {
          dataField: "Open",
          text: "Opened",
          formatter: eventTypeOpenedDateFormatter,
          sort: true,
        },
        {
          dataField: "Click",
          text: "Clicked",
          formatter: eventTypeClickedDateFormatter,
          sort: true,
        }
      );
    }
    const defaultSorted = [
      {
        dataField: "SnsPublishTime",
        order: "desc",
      },
    ];

    const emailLogsList = emailLogs && (
      <div className="postsTable">
        <BootstrapTable
          bootstrap4
          keyField="emailstatisticsUid"
          wrapperClasses="table-responsive"
          data={emailLogs}
          loading={true}
          columns={columns}
          defaultSorted={defaultSorted}
          pagination={paginationFactory()}
          noDataIndication={indication}
        />
      </div>
    );

    return (
      <div>
        <div className="head-wrap d-flex align-items-center justify-content-between flex-column flex-md-row">
          <h1>EMAIL LOGS</h1>
        </div>
        <div className="filters mb-2">
          <form ref={(el) => (this.myFormRef = el)}>
            <h2>Filters</h2>
            <div className="brd-1">
              <div className="row">
                <div className="col-md-6">
                  <div className="date d-flex align-items-center pb-2">
                    <div className="date">
                      <p className="datetext">Sent Date From</p>
                      <DatePicker
                        className="form-control"
                        dateFormat="MMMM d, yyyy"
                        selected={this.state.filterData.start_date}
                        onChange={(date) =>
                          this.handleDateChange(date, "start_date")
                        }
                      />
                      <div className="errorMsg">
                        {this.state.errors["start_date"]}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="date d-flex align-items-center pb-2">
                    <div className="date">
                      <p className="datetext">Sent Date To</p>
                      <DatePicker
                        className="form-control"
                        dateFormat="MMMM d, yyyy"
                        minDate={this.state.filterData.start_date}
                        selected={this.state.filterData.end_date}
                        onChange={(date) =>
                          this.handleDateChange(date, "end_date")
                        }
                      />
                      <div className="errorMsg">
                        {this.state.errors["end_date"]}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="brd-1">
              <h3>Types</h3>
              <div className="row">
                <div className="col-md-3">
                  <label className="typeradio">
                    DIGEST
                    <input
                      type="radio"
                      name="DIGEST"
                      checked={this.state.filterData.types === "DIGEST"}
                      onChange={this.onTypesChange}
                      value="DIGEST"
                    />
                    <span className="radiomark"></span>
                  </label>
                </div>
                <div className="col-md-3">
                  <label className="typeradio">
                    PRINCIPAL
                    <input
                      type="radio"
                      name="PRINCIPAL"
                      checked={this.state.filterData.types === "PRINCIPAL"}
                      onChange={this.onTypesChange}
                      value="PRINCIPAL"
                    />
                    <span className="radiomark"></span>
                  </label>
                </div>
                <div className="col-md-3">
                  <label className="typeradio">
                    DAILYEMAIL
                    <input
                      type="radio"
                      name="DAILYEMAIL"
                      checked={this.state.filterData.types === "DAILYEMAIL"}
                      onChange={this.onTypesChange}
                      value="DAILYEMAIL"
                    />
                    <span className="radiomark"></span>
                  </label>
                </div>
                <div className="col-md-3">
                  <label className="typeradio">
                    Unverified Absence
                    <input
                      type="radio"
                      name="unverified_absence"
                      checked={
                        this.state.filterData.types === "Unverified Absence"
                      }
                      onChange={this.onTypesChange}
                      value="Unverified Absence"
                    />
                    <span className="radiomark"></span>
                  </label>
                </div>
                <div className="col-md-3">
                  <label className="typeradio">
                    Notify Absence
                    <input
                      type="radio"
                      name="notify_absence"
                      checked={this.state.filterData.types === "Notify Absence"}
                      onChange={this.onTypesChange}
                      value="Notify Absence"
                    />
                    <span className="radiomark"></span>
                  </label>
                </div>
              </div>
            </div>
            <div className="brd-1">
              <div className="row">
                <div className="col-md-6">
                  <div className="date pb-2">
                    <p className="datetext">postUid</p>
                    <input
                      name="postUid"
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.filterData.postUid || ""}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="date pb-2">
                    <p className="datetext">Email</p>
                    <input
                      name="email"
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.filterData.email || ""}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end pt-1 flex-column flex-lg-row">
              <div className="">
                {this.state.isReseting && this.state.isLoading && (
                  <button
                    disabled={this.state.isLoading}
                    onClick={this.onReset}
                    className="btn-secondary filter-btn"
                  >
                    Reset ...
                  </button>
                )}
                {!this.state.isReseting && (
                  <button
                    onClick={this.onReset}
                    className="btn-secondary filter-btn"
                  >
                    Reset
                  </button>
                )}
                {this.state.isLoading && this.state.isFitering && (
                  <button
                    disabled={this.state.isLoading}
                    onClick={this.onFilter}
                    className="btn-secondary filter-btn"
                  >
                    Filter ...
                  </button>
                )}
                {!this.state.isFitering && (
                  <button
                    onClick={this.onFilter}
                    className="btn-secondary filter-btn"
                  >
                    Filter
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
        <div className="email-hr-line"></div>
        <div className="row justify-content-between align-items-center text-center flex-wrap emai-log-container pt-3">
          <div>
            <h3>
              {emailLogsData && emailLogsData.sent_count
                ? emailLogsData.sent_count
                : 0}
            </h3>
            <hr />
            <p>Send</p>
          </div>
          <div>
            <h3>
              {emailLogsData && emailLogsData.delivery_count
                ? emailLogsData.delivery_count
                : 0}
            </h3>
            <hr />
            <p>Delivered</p>
          </div>
          <div>
            <h3>
              {emailLogsData && emailLogsData.open_count
                ? emailLogsData.open_count
                : 0}
            </h3>
            <hr />
            <p>Opened</p>
          </div>
          <div>
            <h3>
              {emailLogsData && emailLogsData.click_count
                ? emailLogsData.click_count
                : 0}
            </h3>
            <hr />
            <p>Clicked</p>
          </div>
          <div>
            <h3>
              {emailLogsData && emailLogsData.bounce_count
                ? emailLogsData.bounce_count
                : 0}
            </h3>
            <hr />
            <p>Bounces</p>
          </div>
          <div>
            <h3>
              {emailLogsData && emailLogsData.complaint_count
                ? emailLogsData.complaint_count
                : 0}
            </h3>
            <hr />
            <p>Complaints</p>
          </div>
          {/* <div>
            <h3>0</h3>
            <hr />
            <p>Requested</p>
          </div> */}
        </div>
        <hr></hr>
        {this.props.emailLogsActionLoading === true && (
          <div className="sweet-loading">
            <GridLoader
              css={override}
              sizeUnit={"px"}
              size={40}
              color={"#cadb2a"}
              loading={this.props.emailLogsActionLoading}
            />
          </div>
        )}
        {emailLogsList}
        <hr></hr>
        <div className="d-flex align-items-center">
          <label className="m-r-5">EXPORT TO</label>
          <ExportXlsxCsv Data={this.state.sheetData} fileName="email-logs" />
          <ExportPdf Data={this.state.sheetData} fileName="email-logs" />
        </div>
      </div>
    );
  }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state) {
  console.log("State ==========", state);
  return {
    emailLogsActionLoading: state.emailLogs.actionsloading,
    token: state.user.cognito_data.token,
    emailLogs: Object.values(state.emailLogs.byId),
    emailLogsData: state.emailLogs.data,
    user: state.user.user,
  };
}

function intendedRecipientFormatter(cell, row) {
  if (!cell) {
    return "";
  } else {
    return cell;
  }
}

function dateFormatter(cell, row) {
  if (cell) {
    return moment(cell["SESSendTime"]).format("YYYY-MM-DD hh:mm a");
  } else {
    return "";
  }
}

function eventTypeDeliveredDateFormatter(cell, row, field) {
  if (cell) {
    return moment(cell["SESDeliverTime"]).format("YYYY-MM-DD hh:mm a");
  } else {
    return "";
  }
}
function eventTypeOpenedDateFormatter(cell, row, field) {
  if (cell) {
    return moment(cell["SESOpenTime"]).format("YYYY-MM-DD hh:mm a");
  } else {
    return "";
  }
}
function eventTypeClickedDateFormatter(cell, row, field) {
  if (cell) {
    return moment(cell["SESClickTime"]).format("YYYY-MM-DD hh:mm a");
  } else {
    return "";
  }
}

function postUidFormatter(cell, row) {
  if (cell && cell.length > 0) {
    return cell.join();
  } else {
    return "";
  }
}

function indication() {
  // console.log('111')
  return "No records found!";
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(emailLogsActions, dispatch)
)(EmailLogs);
